<template>
  <div>
    <fcc-botoes-navegacao
      left
      right
      :rightDisabled="buttonDisabled"
      @anterior="$emit('anterior')"
      @proximo="$emit('proximo')"
    />

    <fcc-table
      striped
      hover
      responsive
      pagination
      :items="lista"
      :fields="fields"
      @row-selected="selecionaItens"
    />
  </div>
</template>
<script>
import fccBotoesNavegacao from './fccBotoesNavegacao.vue'

export default {
  components: { fccBotoesNavegacao },
  props: {
    lista: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'codgaplic', label: 'Código Grupo', sortable: true },
        { key: 'grupo', label: 'Grupo', sortable: true }
      ],
      buttonDisabled: true
    }
  },
  methods: {
    selecionaItens(itens) {
      this.buttonDisabled = itens.length === 0
      this.$emit(
        'seleciona-itens',
        itens
          .map((item) => item.iddatagrupo)
          .reduce((acc, curr) => curr + (acc ? `,${acc}` : ''), '')
      )
    }
  }
}
</script>